import { useState } from 'react'

import { Alerts, ModalDel } from '../../../../components'

import Funcs from './functions.delay'
import gridColumns from './columns.json'
import FC from './factory-components.delay'


const DelayModal = ({ dataAll }) => {
  const { Location: location } = dataAll

  const form = Funcs.createForm()
  const [delay, setDelay] = useState({})
  const [isInEdit, setIsInEdit] = useState(false)
  const [toggleDelete, setToggleDelete] = useState(false)
  const activityList = Funcs.useFetchActivityListBySRCode(dataAll.Code)
  const [delayList, setDelayList] = Funcs.useConcatAllDelayList(activityList)
  const taskList = Funcs.useFindTaskList(activityList, form.values.activity_code)
  const [showAlert, setShowAlert] = useState({ visible: false, msg: '', success: false, type: '' })

  const delayTypeOptions = Funcs.useFetchDelayTypeOptions()
  const delayDescOptions = Funcs.useFetchDelayDescOptions(form.values.delay_type_code)

  const handleToggleCancel = Funcs.handleToggleCancelHOF(form, setIsInEdit, delayList, setDelayList)
  const handleToggleEdit = Funcs.handleToggleEditHOF(form, setIsInEdit, location, delayList, setDelayList)
  const handleDeleteDelay = Funcs.handleDeleteDelayHOF(delayList, setDelayList,  delay, setShowAlert, setToggleDelete)

  // This HOF function returns a function that will handle insert data and setState (extending delayList)
  const handleInsertOrUpdateDelay = Funcs.handleInsertOrUpdateDelayHOF(dataAll.Code, isInEdit, form, setDelayList, location, setIsInEdit)

  // Modified useEffect
  Funcs.useCheckChangeOfDuration(form)

  const handleRemoveModal = () => (
    <div>
      <ModalDel
        id='m_actv_delete_mdl'
        toggleDialog={() => setToggleDelete(!toggleDelete)}
        submitDelete={handleDeleteDelay}
        deleteText='Are you sure to delete the data ?'
      />
    </div>
  )

  const deleteData=(item)=>{
    setDelay(item)
    setToggleDelete(!toggleDelete)
  }

  return (
    <div>
      {toggleDelete && handleRemoveModal()}
      <FC.DelayForm
        form={form}
        isInEdit={isInEdit}
        taskList={taskList}
        setDelayList={setDelayList}
        activityList={activityList}
        delayTypeOptions={delayTypeOptions}
        delayDescOptions={delayDescOptions}
        handleInsertOrUpdateDelay={handleInsertOrUpdateDelay}
      />
      <FC.DelayGrid
        data={delayList}
        gridHeight='300px'
        location={location}
        columns={gridColumns}
        handleDeleteDelay={deleteData}
        handleToggleEdit={handleToggleEdit}
        handleToggleCancel={handleToggleCancel}
      />
      <Alerts
        msg={showAlert.msg}
        type={showAlert.type}
        open={showAlert.visible}
        success={showAlert.success}
        close={() => {
          setShowAlert({ ...showAlert, visible: false })
        }}
      />
    </div>
  )
}

export default DelayModal